import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-text">
        <p>Copyright &copy; 2025 by Afrirobot | All Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

